import ScrollToTop from "@/components/utils/ScrollToTop";
import {Navigate, Route, Routes} from "react-router-dom";
import {Box} from "@mui/material";
import React, {lazy} from "react";

import Headers  from '@/components/Headers/Headers';
import LogoutPage from '@/pages/LogoutPage';
// const Headers = lazy(() => import('@/components/Headers/Headers'));
const Step0 = lazy(() => import('@/pages/step0'));
const Step1 = lazy(() => import('@/pages/step1'));
const Step2 = lazy(() => import('@/pages/step2'));
const Step3 = lazy(() => import('@/pages/step3'));
const Step4 = lazy(() => import('@/pages/step4'));
const ThankYouPage = lazy(() => import('@/pages/ThankYouPage'));
const PaymentFailed = lazy(() => import('@/pages/PaymentFailed'));
const HuBOL = () => {
  return (
    <Box pb={5} sx={{minHeight: '100vh'}}>
        <Headers/>
        <ScrollToTop/>
        <Routes>
          <Route path="/search" element={<Step0/>}/>
          <Route path="/search/:search_id" element={<Step1/>}/>
          <Route path="/orders/:item_id" element={<Step2/>}/>
          <Route path="/booking/:cart_id?" element={<Step3/>}/>
          <Route path="/payment/:cart_id?" element={<Step4/>}/>
          <Route path="/thank-you/:reservation_id" element={<ThankYouPage/>}/>
          <Route path="/payment-denied/:cart_id?" element={<PaymentFailed/>}/>
          <Route path="/logout" element={<LogoutPage/>}/>
          <Route path="*" element={<Navigate to="/search" replace/>}/>
        </Routes>
    </Box>
  )
}

export default HuBOL;
